export default __webpack_public_path__ + "static/media/laberinto.f67875d6.jpg";